import { ROLES, type RoleStrategy } from "@pharmupp/p3-front-commons"
import { daysFields } from "./openingHours.const"

const days = Object.values(daysFields).flatMap((dayFields) =>
  Object.values(dayFields),
)

export const openingHoursFormRoleConf: RoleStrategy<
  Record<string, { disabled: boolean }>
> = {
  [ROLES.ADHERENT_TEAM]: {
    ...days.reduce(
      (acc, key) => {
        acc[key] = {
          disabled: true,
        }
        return acc
      },
      {} as Record<string, { disabled: boolean }>,
    ),
  },
}
